<template>
    <div class="imgControlComponentsWrap">
        <div class="showClothesBox">
            <div class="titleLine">试衣效果</div>
            <div class="showBox">
                <div class="leftBox">
                    <div class="smallDes">选择模特</div>
                    <div class="swiperFatherBox">
                        <swiper :options="swiperOption" ref="mySwiper" >
                            <!-- slides -->
                            <swiper-slide v-for="(list,index) in modelLists">
                                <el-image   class="smallPersonImg" :class="{active:list.id==modelId}" :src="list.photo" fit="cover"  @click="clickSmallImg(list)">
                                </el-image>
                            </swiper-slide>
                          </swiper>
                          <div class="swiper-button-prev" slot="button-prev">
                              <i class="el-icon-arrow-up"></i>
                          </div>
                          <div class="swiper-button-next" slot="button-next">
                              <i class="el-icon-arrow-down"></i>
                          </div>
                    </div>
        
        
                </div>
                <div class="centerBox">
                    <el-image :src="bigImg"  class="mainPerson">
                      <div slot="placeholder" class="slotImgArea">
                        加载中
                        <i class="el-icon-loading"></i>
                      </div>
                    </el-image>
                </div>
                <div class="rightBox">
                    <div class="smallDes">拼接</div>
                    <div class="slideBox">
                        <div class="slideLabelBox">
                            <div class="oneItem">1X</div>
                            <div class="oneItem">2X</div>
                            <div class="oneItem">3X</div>
                            <div class="oneItem">4X</div>
                            <div class="oneItem">5X</div>
                        </div>
                        <el-slider tooltip-class="mySlide" @change="changeBeishu"   :show-tooltip="false" v-model="slideNumber" :step="25"
                            vertical height="300px">
                        </el-slider>
                    </div>
                </div>
            </div>
        
        </div>
    </div>
</template>

<script>
    import {ufunction} from '@/utils/tools'
    export default {
        computed: {
        },
        data() {
            return {
                slideNumber: 100,
                modelId:'37',//默认值
                beishu:'1',
                bigImg:'',
                swiperOption: {
                    direction: 'vertical',
                    slidesPerView: 4,
                    spaceBetween: 5,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true // 允许点击小圆点跳转
                    },
                    // slidesOffsetAfter : 50,
                    // slidesOffsetBefore : 50,
                    loop: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }
                },
            }
        },
        created() {
            this.modelLists=ufunction.modelLists
            this.getNewBigImg()
        },
        methods: {
            changeBeishu(){
                if(this.slideNumber==100){
                    this.beishu=1
                }else if(this.slideNumber==75){
                    this.beishu=2
                }else if(this.slideNumber==50){
                    this.beishu=3
                }else if(this.slideNumber==25){
                    this.beishu=4
                }else if(this.slideNumber==0){
                    this.beishu=5
                }
                console.log(this.slideNumber) 
                this.getNewBigImg()
                
            },
            clickSmallImg(list){
                this.modelId=list.id
                this.getNewBigImg()
            },
            getNewBigImg(){
                let publishId=this.$route.query.id
                let url='https://www.bujuyun.com/n-layout-reconciliation/flower/fitting?modelId='+this.modelId+
                '&publishId='+publishId+'&top=0&left=0&max='+this.beishu+'&width=530&height=792'
                console.log(url)
                this.bigImg=url
            },

        }
    }
</script>

<style scoped="scoped" lang="scss">
    .showClothesBox {
        margin-top: 48px;
    
        .titleLine {
            height: 40px;
            padding-left: 21px;
            line-height: 40px;
            background: #F5F5F5;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            border-bottom: 0;
        }
    
        .showBox {
            width: 1184px;
            height: 771px;
            box-sizing: border-box;
            background: #FFFFFF;
            background: #fff;
            border: 1px solid rgba(0, 0, 0, 0.15);
            position: relative;
    
            .leftBox {
                width: 146px;
                height: 674px;
                box-sizing: border-box;
                padding: 20px;
                // border:1px solid red;
                position: absolute;
                top: 46px;
                left: 120px;
    
                .smallDes {
                    font-size: 12px;
                    margin-bottom:44px;
                    margin-top:-20px;
                    padding-left:4px;
                }
    
            }
    
            .centerBox {
                width: 444px;
                height: 632px;
                box-sizing: border-box;
                padding: 20px;
                position: absolute;
                top: 88px;
                left: 370px;
    
                // border:1px solid red;
                .mainPerson {
                    max-width: 100%;
                    max-height: 100%;
                    .slotImgArea{
                        background: #eee;
                        font-size: 16px;
                        line-height: 600px;
                        text-align: center;
                        width: 400px;
                        height: 632px;
                    }
    
                }
            }
    
            .rightBox {
                position: absolute;
                top: 85px;
                right: 150px;
                padding-top: 20px;
                width: 70px;
    
                .smallDes {
                    font-size: 12px;
                }
    
                .slideBox {
                    position: relative;
                    padding-top: 30px;
    
                    .slideLabelBox {
                        height: 300px;
                        position: absolute;
                        bottom: 5px;
                        left: -20px;
    
                        .oneItem {
                            display: block;
                            height: 74px;
                            position: relative;
                            line-height: 10px;
    
                        }
    
                        .oneItem:first-child:after {
                            display: none;
                        }
    
                        .oneItem:last-child:after {
                            display: none;
                        }
    
                        .oneItem:after {
                            content: "";
                            display: block;
                            width: 12px;
                            height: 12px;
                            background: #e1e1e1;
    
                            border-radius: 50%;
                            position: absolute;
                            right: -28px;
                            top: 0;
                        }
                    }
                }
            }
        }
    }
    
    
</style>
<style lang="scss">
    .el-slider__button {
        background: #ff815c;
        width: 22px;
        height: 22px;
        border-radius: 24px;
        border: 2px solid #ffe4d6
    }

    .el-slider__button:hover,
    .el-slider__button.dragging {
        transform: scale(1.1);
    }

    .el-slider.is-vertical .el-slider__runway {
        width: 10px;
        background: #e1e1e1;
        border-radius: 10px;
    }

    .el-slider.is-vertical .el-slider__bar {
        width: 10px;
        background: #e1e1e1;
    }

    .el-slider.is-vertical .el-slider__button-wrapper {
        left: -13px;
    }

    
    .swiperFatherBox {/* 轮播图 */
        position: relative;
        // border: 1px solid blue;
        margin-top:24px;
        
        .smallPersonImg {
            width:100%; height:100%;
            display: block; 
            outline: 1px solid #fff;;
        }
        .smallPersonImg.active{outline:1px solid #fff;}
        .smallPersonImg:hover{cursor: pointer;box-shadow: 0 0 3px #aaa;outline: 1px solid #fff;;}
        .swiper-container {
            width: 100px;
            height: 592px;
            // border: 1px solid red;
            .swiper-slide{background: #ddd;          }
        } 
        .swiper-button-prev,.swiper-button-next{
            position: absolute; z-index:100; background: none; line-height: 30px;
            width: 104px;;height:30px; text-align: center;outline:none;font-weight: bold;
        }
        .swiper-button-prev{
            top:-10px;
            left:0px; 
        }
        .swiper-button-next{
            bottom:-32px;
            left:0px; 
            top:auto;
        }
        .el-icon-arrow-up,.el-icon-arrow-down{font-weight: 900;color:#000}
        .swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{opacity: 0.3;; cursor: not-allowed !important;pointer-events: auto;}
    }

    
</style>
